var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPresenters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1873 8.41345C11.4562 9.37657 10.2997 10 9 10C6.79436 10 5 8.20564 5 6C5 3.79436 6.79436 2 9 2C10.2997 2 11.4562 2.62343 12.1873 3.58655C12.6968 4.25791 13 5.09406 13 6C13 6.90594 12.6968 7.74209 12.1873 8.41345Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.0769C17 20.5867 16.5328 21 15.9565 21H2.04348C1.4672 21 1 20.5867 1 20.0769C1 16.1747 4.5888 13 9 13C10.2452 13 11.4248 13.2531 12.4767 13.7039C13.2482 14.0347 13.9507 14.4721 14.5603 14.994C15.8277 16.0794 16.6919 17.5309 16.9319 19.1538C16.9766 19.4561 17 19.7641 17 20.0769Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9885 21H21.9565C22.5328 21 23 20.5867 23 20.0769C23 19.7641 22.9766 19.4561 22.9319 19.1538C22.6919 17.5309 21.8277 16.0794 20.5603 14.994C19.9507 14.4721 19.2482 14.0347 18.4767 13.7039C17.4248 13.2531 16.2452 13 15 13C14.5877 13 14.1826 13.0277 13.787 13.0812C14.5791 13.465 15.3063 13.941 15.9503 14.4925C17.5346 15.8492 18.6149 17.6636 18.9149 19.6923C18.9708 20.0701 19 20.4552 19 20.8462C19 20.8983 18.9961 20.9497 18.9885 21Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 7.03522 13.6833 7.99753 13.1423 8.79622C13.8689 9.53863 14.8816 10 16 10C17.2997 10 18.4562 9.37657 19.1873 8.41345C19.6968 7.74209 20 6.90594 20 6C20 5.09406 19.6968 4.25791 19.1873 3.58655C18.4562 2.62343 17.2997 2 16 2C14.8816 2 13.8689 2.46137 13.1423 3.20378C13.6833 4.00247 14 4.96478 14 6Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPresenters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-presenters.ec172c265cb4b3a180f87426c6d070a8.svg";